import React from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import Images from "assets/images"
import { EDIT } from "const"
import { mtModulesRoute } from "client/parts/routes"
import {
    StoreType,
    addModal,
} from "client/store"
import {
    PageForm,
    Logo,
    FormGroup,
    Label,
    Input,
    CKEditor,
    Button,
} from "client/components"


const Form = () => {
    const module = useSelector((state: StoreType) => state.module.moduleView)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const editUrl = `${mtModulesRoute}/${EDIT}/${module.id}`

    return (
        <PageForm>
            <Row>
                <Col xs={12} md={3}>
                    <Logo logo={module.logo || Images.defaultLogo} />
                </Col>
                <Col xs={12} md={9}>
                    <Row>
                        <Col xs={12} md={8}>
                            <FormGroup>
                                <Label>{lang.name}</Label>
                                <Input type="text" value={module.name} readOnly />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={4}>
                            <FormGroup>
                                <Label>{lang.shortName}</Label>
                                <Input type="text" value={module.shortName} readOnly />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <FormGroup>
                                <Label>{lang.description}</Label>
                                <CKEditor
                                    data={module.description}
                                    isReadOnly
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>{lang.copyright}</Label>
                                <CKEditor
                                    data={module.copyright}
                                    isReadOnly
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>{lang.status}</Label>
                                <Input type="text" value={lang[module.status]} readOnly />
                            </FormGroup>
                        </Col>
                        <Col xs={12}>
                            <Button onClick={() => dispatch(addModal({ url: editUrl }))}>
                                {lang.edit}
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </PageForm>
    )
}
export default Form
